import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { Checkbox as MUICheckbox, FormControlLabel } from '@mui/material';
import { CommonFieldProps } from '../form.types';

export type CheckboxFieldProps<T extends FieldValues> = Omit<
  CommonFieldProps<T>,
  'value' | 'onChange'
> & {
  type: 'checkbox';
  checked?: boolean;
  onChange?: (checked: boolean) => any;
};

export const CheckboxField = <T extends FieldValues>({
  name,
  label,
  onChange,
  checked
}: CheckboxFieldProps<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <MUICheckbox
              // Bind to RHF state by default so checkbox value is restored
              // when form data is reloaded (e.g. reopening TradingForm).
              checked={checked ?? Boolean(field.value)}
              onChange={(e) => {
                const checked = e.target.checked;
                // If an onChange transform is provided, use it; otherwise, pass the raw boolean.
                field.onChange(onChange ? onChange(checked) : checked);
              }}
            />
          }
          label={label}
        />
      )}
    />
  );
};
